"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyVestingContract = exports.emptyContract = void 0;
exports.emptyContract = { id: 1, address: "" };
const vestingParameters = {
    account: "",
    startTimestamp: new Date().toISOString(),
    cliffInMonth: 12,
    monthlyRelease: 1000,
};
exports.emptyVestingContract = {
    id: 1,
    address: "",
    parameters: vestingParameters,
};
//# sourceMappingURL=empty-contract.js.map